var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelemetrySShotEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#B1CBD9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.9499 28.0502C40.6836 30.7839 40.6836 35.216 37.9499 37.9497M28.0504 37.9497C25.3167 35.216 25.3167 30.7838 28.0504 28.0502M24.7506 41.2495C20.1945 36.6934 20.1945 29.3065 24.7506 24.7504M41.2497 24.7504C45.8059 29.3065 45.8059 36.6935 41.2497 41.2496M35.3335 32.9999C35.3335 34.2886 34.2888 35.3333 33.0002 35.3333C31.7115 35.3333 30.6668 34.2886 30.6668 32.9999C30.6668 31.7113 31.7115 30.6666 33.0002 30.6666C34.2888 30.6666 35.3335 31.7113 35.3335 32.9999Z",
    stroke: "#365A6D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    stroke: "#D0E0E8",
    strokeWidth: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelemetrySShotEmpty);
export default __webpack_public_path__ + "static/media/telemetrySShotEmpty.bba576aa635f70a7e62587fde0ec2831.svg";
export { ForwardRef as ReactComponent };